import Orders from "./Orders";
new Orders();